import React, { useRef } from 'react';
import logo from '../../assets/images/SHTATO LOGO.jpg';

const Receipt = ({ table, tableItems, calculateTotal, paymentType, discount, invoiceNumber }) => {
    const formattedInvoiceNumber = String(invoiceNumber).padStart(5, '0');

    return (
        <div className="receipt-wrapper print:block print:w-full print:max-w-lg print:mx-auto print:shadow-none">
            <style>
                {`
                    @media print {
                        @page {
                            size: 55mm 91mm;
                            margin: 0;
                        }
                        body * {
                            visibility: hidden;
                        }
                        .receipt-wrapper, .receipt-wrapper * {
                            visibility: visible;
                        }
                        .receipt-wrapper {
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 80mm !important;
                            text-align: center;
                            padding: 8px;
                            font-size: 9px;
                        }
                        .receipt-logo {
                            width: 60px !important;
                            margin-bottom: 4px !important;
                        }
                        .receipt-header {
                            margin-bottom: 6px !important;
                        }
                        .receipt-items {
                            margin-bottom: 6px !important;
                        }
                        .receipt-item {
                            margin-bottom: 2px !important;
                        }
                        .receipt-footer {
                            margin-top: 6px !important;
                        }
                    }
                `}
            </style>

            <div className="text-center mb-4 receipt-header">
                <img src={logo} alt="SHTATTO'" className="mx-auto mb-2 w-24 receipt-logo" />
            </div>

            <div className="mb-4 text-sm receipt-header">
                <div className="flex justify-between mb-1">
                    <span>FACTURE: {formattedInvoiceNumber}</span>
                    <span>DATE: {new Date().toLocaleDateString()}</span>
                </div>
                <div className="flex justify-between mb-1">
                    <span>TABLE: {table?.tableNumber}</span>
                    <span>SHTATTO TEAM</span>
                </div>
            </div>

            <div className="mb-4 receipt-items">
                <div className="flex justify-between text-sm font-bold mb-2">
                    <span className="w-12">QTE</span>
                    <span className="flex-grow px-2">PRODUITS</span>
                    <span className="w-20 text-right">TOTAL</span>
                </div>
                <div className="border-t border-b border-dashed border-gray-400 py-2">
                    {tableItems?.map((item, index) => (
                        <div key={index} className="flex justify-between text-sm mb-1 receipt-item">
                            <span className="w-12">{String(item.quantity).padStart(2, '0')}</span>
                            <span className="flex-grow px-2">{item.name.toUpperCase()}</span>
                            <span className="w-20 text-right">{(item.price * item.quantity).toFixed(2)} MAD</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="text-sm">
                <div className="flex font-semibold justify-between mb-1">
                    <span>TOTAL TTC</span>
                    <span>{calculateTotal().toFixed(2)} MAD</span>
                </div>
                {discount && (
                    <div className="flex justify-between mb-1">
                        <span>Discount</span>
                        <span>{discount.toFixed(2)} MAD</span>
                    </div>
                )}
                <div className="flex justify-between mb-1">
                    <span>TVA 10%</span>
                    <span>{(calculateTotal() * 0.1).toFixed(2)} MAD</span>
                </div>
                <div className="mb-2">
                    <div>
                        PAIEMENT PAR : {paymentType === 'cash' ? 'Espèce' : paymentType === 'card' ? 'Carte' : paymentType}
                    </div>
                    <div>HEURE D'OUVERTURE : {new Date().toLocaleTimeString()}</div>
                </div>
            </div>

            <div className="text-center text-xs mt-4 receipt-footer">
                <h2>THANK YOU FOR YOUR VISIT</h2>
            </div>
        </div>
    );
};

export default Receipt;